import {
  DataDeclarationIcaro,
  SubjectIcaroVM,
} from 'civil-status/view-models/form-declaration-icaro';
import { DateTime } from 'luxon';
import { formatNameIcaro, formatSurnameIcaro } from '../format-surname-name-icaro';
import { formatTime } from '../format-time';

export const transformerBorn = (data: DataDeclarationIcaro): SubjectIcaroVM | undefined => {
  if (!data) {
    return undefined;
  }

  return {
    freshman: data.matricolaNeonato?.toString() || '',
    numberFamily: data.codiceFamiglia?.toString() || '',
    surname: formatSurnameIcaro(data.nominativo),
    name: formatNameIcaro(data.nominativo),
    dateBorn: data.dataNascita ? DateTime.fromFormat(data.dataNascita, 'yyyyMMdd') : null,
    municipalityBorn: data.comuneNascitaNatoDescrizione || '',
    placeBorn: data.svdOspedaleDescrizione || '',
    numberAct: data.attoNascita || '',
    nameAffective: data.nominativoAff || '',
    gender: data.sesso || '',
    numberTwins: data.numeroGemelli || undefined,
    timeBorn: data.oraNascita
      ? DateTime.fromFormat(formatTime(data.oraNascita?.toString()), 'HHmm')
      : null,
  };
};
